(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/big/assets/javascripts/views/big-statistics-view_desktop.js') >= 0) return;  svs.modules.push('/components/statistics/big/assets/javascripts/views/big-statistics-view_desktop.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.big = svs.statistics.big || {};
  svs.statistics.big.views = svs.statistics.big.views || {};

  svs.statistics.big.views.BigStatisticsView = Backbone.Marionette.View.extend({
    template: function(data) {
      return svs.statistics.big.templates.big_main(data);
    },
    regions: {
      header: '.js-big-header',
      content: '.js-big-content'
    },
    events: {
      'click .big-close-button': 'backButtonClick'
    },
    log: new svs.core.log.Logger('svs.statistics.views.BigStatisticsView'),

    initialize: function(options) {
      options = _.defaults({}, options, {
        favoritesModalHeaderClass: null
      });

      this.options = options;
    },

    formatMatchData: function() {
      if (_.isObject(this.model) && _.isObject(this.model.get('match'))) {
        var homeTeam = '',
          awayTeam = '',
          matchObj = this.model.get('match'),
          match;
        if (!matchObj.isPlayer) {
          if (_.isObject(matchObj.participants)) {
            homeTeam = matchObj.participants[0].mediumName;
          } else if (_.isObject(matchObj.homeTeam)) {
            homeTeam = matchObj.homeTeam.mediumName;
          }

          if (_.isObject(matchObj.participants)) {
            awayTeam = matchObj.participants[1].mediumName;
          } else if (_.isObject(matchObj.awayTeam)) {
            awayTeam = matchObj.awayTeam.mediumName;
          }

          match = homeTeam + ' - ' + awayTeam;
        }
        this.options.matchId = matchObj.matchId;
        this.options.label = match;
        this.trigger('openRegion', this.options);
      }
    },
    resizeRoyalSlider: function() {
      this.trigger('resizeRoyalSlider');
    },
    backButtonClick: function() {
      if (_.isFunction(this.options.backButtonCallback)) {
        this.options.backButtonCallback();
      }

      this.trigger('updateTabUrl');
    },
    onRender: function() {
      if (_.isObject(this.model) && this.model.get('hasMatch')) {
        this.showTab();
      } else {
        $('.big-content').html(svs.statistics.statistics.templates.nodata({}));
      }
      this.showHeader();
      this.postShow();
    },
    postShow: function() {
      if (_.isObject(this.model) && _.isObject(this.model.get('match'))) {
        this.formatMatchData();
      } else if (this.options.preDraw) {
        this.showTab(this.options.preDraw);
        this.trigger('openRegion', this.options);
      }
    },
    showTab: function(showEmptyPlate) {
      if (showEmptyPlate) {
        this.tabs = new svs.statistics.big.views.BigStatisticsTabs({
          preDraw: showEmptyPlate
        });
      } else {
        this.tabs = new svs.statistics.big.views.BigStatisticsTabs({
          model: this.model,
          selectedTab:
            this.options && this.options.selectedTab
              ? this.options.selectedTab
              : undefined,
          match: this.model.get('match'),
          path: this.options && !!this.options.path,
          usePageScroll: this.options && !!this.options.usePageScroll
        });
      }
      this.listenTo(this.tabs, 'resizeRoyalSlider', this.resizeRoyalSlider);
      this.showChildView('content', this.tabs);
    },
    showHeader: function() {
      var header = new svs.statistics.big.views.BigStatisticsHeader({
        app: this.options.app,
        model: this.model,
        favoritesModalHeaderClass: this.options.favoritesModalHeaderClass
      });

      this.showChildView('header', header);
    },
    onDestroy: function() {
      this.stopListening();

      if (this.tabs) {
        this.tabs.destroy();
        this.tabs = null;
      }
    }
  });
})(Backbone, _, svs);

 })(window);